import { FC, ReactNode } from 'react';
import {
  EvaluationResultSpecific,
  Metric,
} from '@agilelab/plugin-wb-governance-common';
import { GovernanceTestOverviewMetricSimple } from './OverviewMetricSimpleVariant';
import { GovernanceTestOverviewMetricTabs } from './OverviewMetricTabs';

interface CommonProps {
  children?: ReactNode;
}

type ConditionalProps =
  | {
      kind: 'simple';
      metric: Metric;
    }
  | {
      kind: 'tabs';
      result?: EvaluationResultSpecific;
      metric: Metric;
      infoContent?: JSX.Element;
      test?: {
        errors?: string[];
        content: string;
        name: string;
      };
    };

type Props = CommonProps & ConditionalProps;

export const GovernanceTestOverviewMetric: FC<Props> = props => {
  switch (props.kind) {
    case 'simple':
      return <GovernanceTestOverviewMetricSimple {...props} />;
    case 'tabs':
      return <GovernanceTestOverviewMetricTabs {...props} />;
    default:
      return <></>;
  }
};
